import type { RateTables } from './types.js';

export const rateTables2026: RateTables = {
  schemaVersion: 1,
  versions: {
    privateRulePolicy: '2026.1',
    publicServantRates: 'mpm-216-2026-07-01',
    fourInsurance: '2026.07',
    businessIncome3_3: '2026.1',
    employmentOnly: '2026.1',
    minWage: '2026',
  },
  provenance: {
    privateRulePolicy: {
      version: '2026.1', effectiveFrom: '2026-01-01', effectiveTo: null,
      sourceUrl: 'https://law.go.kr/lsLinkCommonInfo.do?chrClsCd=010202&lsJoLnkSeq=1025590529',
      checkedAt: '2026-08-08T00:00:00+09:00', checksum: 'f2e26ec942d4e02d5333bdc05c4f239329d5da7049c91d1d8a7f8ee6f26a2259',
    },
    publicServantRates: {
      version: 'mpm-216-2026-07-01', effectiveFrom: '2026-07-01', effectiveTo: null,
      sourceUrl: 'https://law.go.kr/LSW/admRulLsInfoP.do?admRulId=29532&efYd=0',
      checkedAt: '2026-08-08T00:00:00+09:00', checksum: 'ac772c8171826986441b94a6d116ef978d743faa6c37df7633c9c254b0aec9fb',
    },
    fourInsurance: {
      version: '2026.07', effectiveFrom: '2026-07-01', effectiveTo: null,
      sourceUrl: 'https://www.nps.or.kr/pnsinfo/ntpsklg/getOHAF0038M0.do?menuId=MN24001113&tab=tab5',
      checkedAt: '2026-08-08T00:00:00+09:00', checksum: '992f9d30f10d29475cdb3db03d93f807ac19baf7556ba204a4abadf4b5d4af86',
    },
    businessIncome3_3: {
      version: '2026.1', effectiveFrom: '2026-01-01', effectiveTo: null,
      sourceUrl: 'https://law.go.kr/법령/소득세법시행령/제184조',
      checkedAt: '2026-08-08T00:00:00+09:00', checksum: 'bc4330fb67cc29fbd5f920bcc3c1fc9a915717ec6b8cef8705696597d64428bb',
    },
    employmentOnly: {
      version: '2026.1', effectiveFrom: '2026-01-01', effectiveTo: null,
      sourceUrl: 'https://www.ei.go.kr/ei/eih/cm/hm/main.do',
      checkedAt: '2026-08-08T00:00:00+09:00', checksum: '064e91e56d13ea4ceca261f26cddfff20cd64739e55554d2d6ce471048a0d885',
    },
    minWage: {
      version: '2026', effectiveFrom: '2026-01-01', effectiveTo: '2026-12-31',
      sourceUrl: 'https://www.minimumwage.go.kr/index.jsp',
      checkedAt: '2026-08-08T00:00:00+09:00', checksum: '66cfa443f9a3002dd9612c73de0d79445b6022d7613fe48756568880378e7d2a',
    },
  },
  privateRulePolicy: {
    version: '2026.1',
    effectiveFrom: '2026-01-01',
    source: {
      title: '근로기준법 제56조',
      url: 'https://law.go.kr/lsLinkCommonInfo.do?chrClsCd=010202&lsJoLnkSeq=1025590529',
      checkedAt: '2026-08-08T00:00:00+09:00',
    },
    overtimePremium: { numerator: 1, denominator: 2 },
    nightPremium: { numerator: 1, denominator: 2 },
    holidayPremium: { numerator: 1, denominator: 2 },
    holidayOverPremium: { numerator: 1, denominator: 1 },
    classificationReview: { dailyOvertimeAndHoliday: 'legal_review_required' },
  },
  publicServantSource: {
    title: '공무원보수 등의 업무지침 인사혁신처예규 제216호 별표 2',
    url: 'https://law.go.kr/LSW/admRulLsInfoP.do?admRulId=29532&efYd=0',
    checkedAt: '2026-08-08T00:00:00+09:00',
  },
  publicServantRates: {
    general5: { id: 'general5', overtimeHourly: 16053, nightHourly: 5351, holidayDaily: 129043 },
    general6: { id: 'general6', overtimeHourly: 13692, nightHourly: 4564, holidayDaily: 110065 },
    general7: { id: 'general7', overtimeHourly: 12368, nightHourly: 4123, holidayDaily: 99422 },
    general8: { id: 'general8', overtimeHourly: 12113, nightHourly: 4038, holidayDaily: 97373 },
    general9: { id: 'general9', overtimeHourly: 10949, nightHourly: 3650, holidayDaily: 88017 },
    policeFireCommand: { id: 'policeFireCommand', overtimeHourly: 16960, nightHourly: 5653, holidayDaily: 136331 },
    policeFireSenior: { id: 'policeFireSenior', overtimeHourly: 15082, nightHourly: 5027, holidayDaily: 121237 },
    policeFireLieutenant: { id: 'policeFireLieutenant', overtimeHourly: 13779, nightHourly: 4593, holidayDaily: 110763 },
    policeFireSergeant: { id: 'policeFireSergeant', overtimeHourly: 12934, nightHourly: 4311, holidayDaily: 103969 },
    policeFireCorporal: { id: 'policeFireCorporal', overtimeHourly: 12584, nightHourly: 4195, holidayDaily: 101153 },
    policeFireEntry: { id: 'policeFireEntry', overtimeHourly: 11175, nightHourly: 3725, holidayDaily: 89830 },
  },
  taxRates: {
    fourInsurance: {
      nationalPensionRate: 0.0475,
      nationalPensionCap: 6_590_000,
      healthInsuranceRate: 0.03595,
      longTermCareRateOfHealth: 0.1314,
      employmentRate: 0.009,
    },
    businessIncome3_3: { incomeTaxRate: 0.03, localTaxRate: 0.003 },
    employmentOnly: { employmentRate: 0.009 },
  },
  minimumWage: {
    hourly: 10320, year: 2026,
    source: { title: '2026년 적용 최저임금', url: 'https://www.minimumwage.go.kr/index.jsp', checkedAt: '2026-08-08T00:00:00+09:00' },
  },
};
